import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { CheckIcon } from "../icons";
import S from "../styles";

const API_URL = process.env.REACT_APP_API_URL || "https://api.nycmanufacturing.com";

const HQ_SECTIONS = [
  { key: "revenue", label: "Revenue" },
  { key: "expenses", label: "Expenses" },
  { key: "cutcost", label: "Job Cost Calculator" },
  { key: "progress", label: "Open Jobs" },
  { key: "history", label: "Job History" },
  { key: "customers", label: "Customers" },
  { key: "employees", label: "Employees" },
  { key: "timeclock", label: "Time Clock" },
  { key: "equipment", label: "Equipment & Maintenance" },
  { key: "supplies", label: "Materials & Supplies" },
  { key: "instantquoting", label: "Instant Quoting" },
  { key: "tour-requests", label: "Tour Requests" },
  { key: "product-dev", label: "Product Development" },
  { key: "printfarm", label: "PrintFarm" },
  { key: "qrgenerator", label: "QR Generator" },
  { key: "pdfcombiner", label: "PDF Combiner" },
  { key: "etsylabelbot", label: "Etsy Label Bot" },
  { key: "settings", label: "Settings" },
];

const STORE_PAGE_KEYS = ["dashboard", "revenue", "trends", "expenses", "products", "inventory", "support", "requests", "supplies"];
const STORE_PAGE_LABELS = {
  dashboard: "Dashboard", revenue: "Revenue", trends: "Trends", expenses: "Expenses", products: "Products",
  inventory: "Inventory", support: "Support Tickets", requests: "Requests", supplies: "Hardware & Supplies",
};

const DS_SECTIONS = [...STORE_PAGE_KEYS.map((k) => ({ key: `ds-${k}`, label: STORE_PAGE_LABELS[k] })), { key: "ds-financing", label: "Financing" }, { key: "ds-etsy", label: "Etsy" }, { key: "ds-tiktok", label: "TikTok Shop" }, { key: "ds-shopify", label: "Shopify" }, { key: "ds-amazon", label: "Amazon" }];
const VV_SECTIONS = [...STORE_PAGE_KEYS.map((k) => ({ key: `vv-${k}`, label: STORE_PAGE_LABELS[k] })), { key: "vv-reverb", label: "Reverb" }, { key: "vv-etsy", label: "Etsy" }, { key: "vv-amazon", label: "Amazon" }, { key: "vv-ebay", label: "eBay" }, { key: "vv-listing-migrator", label: "Listing Migrator" }, { key: "vv-filament", label: "Filament Usage" }];

// ─── Edit Popup ───────────────────────────────────────
function PermissionPopup({ section, employees, onClose, onRefresh }) {
  const empsWith = employees.filter((e) => (e.permissions || []).includes(section.key));
  const empsWithout = employees.filter((e) => !(e.permissions || []).includes(section.key));

  const toggle = (emp, grant) => {
    const current = emp.permissions || [];
    const updated = grant ? [...current, section.key] : current.filter((k) => k !== section.key);
    fetch(`${API_URL}/api/employees/${emp.id}`, {
      method: "PUT", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ permissions: updated }),
    }).then(() => onRefresh());
  };

  return ReactDOM.createPortal(
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={onClose} style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.6)" }} />
      <div style={{ position: "relative", width: "100%", maxWidth: 480, background: "#F4F2EC", border: "2px solid #0A0A0F", borderRadius: 0, overflow: "hidden", zIndex: 301, maxHeight: "80vh", display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "16px 20px", background: "#FFFFFF", borderBottom: "2px solid #0A0A0F", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 16, fontWeight: 700, color: "#0A0A0F" }}>{section.label}</span>
          <button onClick={onClose} style={{ background: "none", border: "2px solid #0A0A0F", borderRadius: 0, padding: "4px 8px", cursor: "pointer", color: "rgba(10,10,15,0.58)", display: "flex", alignItems: "center" }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          </button>
        </div>
        <div style={{ padding: 20, overflowY: "auto", flex: 1 }}>
          {/* Has access */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1.2, color: "rgba(10,10,15,0.58)", marginBottom: 10 }}>Has Access</div>
            {empsWith.length === 0 && <div style={{ fontSize: 14, color: "rgba(10,10,15,0.58)", padding: "8px 0" }}>No employees have access</div>}
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {empsWith.map((emp) => (
                <div key={emp.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: "#FFFFFF", borderRadius: 0, border: "2px solid #0A0A0F" }}>
                  <div>
                    <span style={{ fontSize: 15, fontWeight: 600, color: "#0A0A0F" }}>{emp.name}</span>
                    <span style={{ fontSize: 13, color: "rgba(10,10,15,0.58)", marginLeft: 8 }}>{emp.position}</span>
                  </div>
                  <button onClick={() => toggle(emp, false)} style={{
                    padding: "4px 12px", borderRadius: 0, border: "1px solid #ef4444",
                    background: "transparent", color: "#ef4444", fontSize: 12, fontWeight: 600,
                    cursor: "pointer", fontFamily: "'Archivo', sans-serif",
                  }}>
                    Remove
                  </button>
                </div>
              ))}
            </div>
          </div>
          {/* No access */}
          {empsWithout.length > 0 && (
            <div>
              <div style={{ fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1.2, color: "rgba(10,10,15,0.58)", marginBottom: 10 }}>No Access</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {empsWithout.map((emp) => (
                  <div key={emp.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: "#FFFFFF", borderRadius: 0, border: "2px solid #0A0A0F40" }}>
                    <div>
                      <span style={{ fontSize: 15, fontWeight: 500, color: "rgba(10,10,15,0.58)" }}>{emp.name}</span>
                      <span style={{ fontSize: 13, color: "rgba(10,10,15,0.45)", marginLeft: 8 }}>{emp.position}</span>
                    </div>
                    <button onClick={() => toggle(emp, true)} style={{
                      padding: "4px 12px", borderRadius: 0, border: "1px solid #22c55e",
                      background: "transparent", color: "#22c55e", fontSize: 12, fontWeight: 600,
                      cursor: "pointer", fontFamily: "'Archivo', sans-serif",
                    }}>
                      Grant
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}

// ─── Owner Profit Splits ─────────────────────────────
function OwnerProfitSplits({ store, readOnly }) {
  const storeKey = store === "designshop" ? "designshop" : "vibratovault";
  const storeLabel = store === "designshop" ? "Design Shop" : "Vibrato Vault";
  const [splits, setSplitsState] = useState([]);
  const [saving, setSaving] = useState({});
  const [msg, setMsg] = useState("");

  useEffect(() => {
    fetch(`${API_URL}/api/profit-splits?store=${storeKey}`).then((r) => r.json()).then((d) => setSplitsState(d.splits || [])).catch(() => {});
  }, [storeKey]);

  const totalPct = (splits) => splits.reduce((s, o) => s + (parseFloat(o.percentage) || 0), 0);
  const canSave = (splits) => {
    const t = totalPct(splits);
    return splits.length > 0 && Math.abs(t - 100) < 0.02 && splits.every((o) => (o.name || "").trim());
  };

  const saveSplits = (storeKey, splits) => {
    setSaving((p) => ({ ...p, [storeKey]: true }));
    fetch(`${API_URL}/api/profit-splits`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ store: storeKey, splits: splits.map((o) => ({ name: o.name.trim(), percentage: parseFloat(o.percentage) || 0 })) }),
    })
      .then((r) => r.json())
      .then((d) => {
        if (d.error) setMsg(d.error);
        else { setMsg("Saved!"); setTimeout(() => setMsg(""), 2000); }
      })
      .catch(() => setMsg("Error saving"))
      .finally(() => setSaving((p) => ({ ...p, [storeKey]: false })));
  };

  if (readOnly) {
    return (
      <div style={{ background: "#FFFFFF", border: "2px solid #0A0A0F", borderRadius: 0, padding: 20, marginBottom: 24 }}>
        <h3 style={{ fontSize: 14, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1.5, color: "rgba(10,10,15,0.58)", marginBottom: 14 }}>{storeLabel} — Owner Profit Splits</h3>
        {splits.length === 0 ? (
          <p style={{ fontSize: 14, color: "rgba(10,10,15,0.58)" }}>No ownership splits configured.</p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {splits.map((owner, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: "#FFFFFF", borderRadius: 0, border: "2px solid #0A0A0F" }}>
                <span style={{ fontSize: 15, fontWeight: 600, color: "#0A0A0F" }}>{owner.name}</span>
                <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 15, fontWeight: 600, color: "#0033FF" }}>{owner.percentage}%</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  const renderStore = (label, storeKey, splits, setSplits) => {
    const t = totalPct(splits);
    return (
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: "#0A0A0F", marginBottom: 10 }}>{label}</div>
        {splits.map((owner, i) => (
          <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
            <input
              value={owner.name}
              onChange={(e) => { const u = [...splits]; u[i] = { ...u[i], name: e.target.value }; setSplits(u); }}
              placeholder="Owner name"
              style={{ ...S.input, flex: 1 }}
            />
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <input
                type="number"
                value={owner.percentage}
                onChange={(e) => { const u = [...splits]; u[i] = { ...u[i], percentage: e.target.value }; setSplits(u); }}
                placeholder="0"
                style={{ ...S.input, width: 70, textAlign: "right" }}
                min="0" max="100"
              />
              <span style={{ color: "rgba(10,10,15,0.58)", fontSize: 14 }}>%</span>
            </div>
            <button
              onClick={() => setSplits(splits.filter((_, j) => j !== i))}
              style={{ ...S.iconBtn, borderColor: "#ef4444", color: "#ef4444", padding: "4px 8px", fontSize: 12 }}
            >×</button>
          </div>
        ))}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 8 }}>
          <button
            onClick={() => splits.length < 10 && setSplits([...splits, { name: "", percentage: "" }])}
            style={{ ...S.iconBtn, padding: "4px 12px", fontSize: 13 }}
          >+ Add Owner</button>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {splits.length > 0 && (
              <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 13, color: Math.abs(t - 100) < 0.02 ? "#34d399" : "#ef4444", fontWeight: 600 }}>
                Total: {t}%
              </span>
            )}
            <button
              onClick={() => saveSplits(storeKey, splits)}
              disabled={!canSave(splits) || saving[storeKey]}
              style={{
                padding: "6px 16px", borderRadius: 0, border: "1px solid #22c55e",
                background: canSave(splits) ? "#22c55e" : "transparent",
                color: canSave(splits) ? "#0c3a2a" : "rgba(10,10,15,0.58)",
                fontSize: 13, fontWeight: 600, cursor: canSave(splits) ? "pointer" : "not-allowed",
                opacity: canSave(splits) ? 1 : 0.5, fontFamily: "'Archivo', sans-serif",
              }}
            >{saving[storeKey] ? "Saving..." : "Save"}</button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{ background: "#FFFFFF", border: "2px solid #0A0A0F", borderRadius: 0, padding: 20, marginBottom: 24 }}>
      <h3 style={{ fontSize: 14, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1.5, color: "rgba(10,10,15,0.58)", marginBottom: 14 }}>{storeLabel} — Owner Profit Splits</h3>
      {msg && <div style={{ fontSize: 13, color: msg === "Saved!" ? "#34d399" : "#ef4444", marginBottom: 10 }}>{msg}</div>}
      {renderStore(storeLabel, storeKey, splits, setSplitsState)}
    </div>
  );
}

// ─── AI / API Keys (CEO only) ─────────────────────────
function AIKeysCard() {
  const [info, setInfo] = useState({ anthropicConfigured: false, openaiConfigured: false, provider: "anthropic" });
  const [anthropicInput, setAnthropicInput] = useState("");
  const [openaiInput, setOpenaiInput] = useState("");
  const [provider, setProvider] = useState("anthropic");
  const [ceoPassword, setCeoPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const currentUser = (() => {
    try { return JSON.parse(sessionStorage.getItem("nycmfg-user")); } catch { return null; }
  })();

  useEffect(() => {
    fetch(`${API_URL}/api/settings/ai-keys`)
      .then((r) => r.json())
      .then((d) => { setInfo(d); setProvider(d.provider || "anthropic"); })
      .catch(() => {});
  }, []);

  const save = () => {
    setSaving(true); setErr(""); setMsg("");
    // The backend verifies CEO credentials before writing — passwords are
    // hashed server-side and never stored client-side, so the CEO types it here.
    fetch(`${API_URL}/api/settings/ai-keys`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        empId: currentUser?.empId,
        password: ceoPassword,
        anthropicKey: anthropicInput.trim(),
        openaiKey: openaiInput.trim(),
        provider,
      }),
    })
      .then(async (r) => {
        const d = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(d.error || `Server returned ${r.status}`);
        return d;
      })
      .then((d) => {
        setInfo(d); setProvider(d.provider || "anthropic");
        setAnthropicInput(""); setOpenaiInput(""); setCeoPassword("");
        setMsg("Saved!"); setTimeout(() => setMsg(""), 2000); setSaving(false);
      })
      .catch((e) => { setErr(`Failed to save: ${e.message}`); setSaving(false); });
  };

  const dirty = anthropicInput.trim() || openaiInput.trim() || provider !== info.provider;
  const canSave = dirty && ceoPassword.trim();

  const statusPill = (ok) => (
    <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 13, fontWeight: 600, color: ok ? "#34d399" : "rgba(10,10,15,0.45)" }}>
      {ok ? "Configured ✓" : "Not set"}
    </span>
  );

  const provBtn = (val, label) => (
    <button onClick={() => setProvider(val)} style={{
      padding: "6px 16px", borderRadius: 0, border: "2px solid #0A0A0F",
      background: provider === val ? "#0033FF" : "transparent",
      color: provider === val ? "#FFFFFF" : "#0A0A0F",
      fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "'Archivo', sans-serif",
      textTransform: "uppercase", letterSpacing: "0.04em",
    }}>{label}</button>
  );

  return (
    <div style={{ background: "#FFFFFF", border: "2px solid #0A0A0F", borderRadius: 0, padding: 20, marginBottom: 24 }}>
      <h3 style={{ fontSize: 14, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1.5, color: "rgba(10,10,15,0.58)", marginBottom: 6 }}>AI / API Keys</h3>
      <p style={{ fontSize: 13, color: "rgba(10,10,15,0.58)", marginBottom: 16, lineHeight: 1.5 }}>
        These keys power every AI feature across the NYC Manufacturing suite (web, iOS, Chrome extension).
        Keys are stored on the server and never displayed. Only your CEO account can see or change them.
      </p>

      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em", color: "rgba(10,10,15,0.58)", marginBottom: 6, fontFamily: "'JetBrains Mono', monospace" }}>Active Provider</div>
        <div style={{ display: "flex", gap: 8 }}>
          {provBtn("anthropic", "Anthropic")}
          {provBtn("openai", "OpenAI")}
        </div>
      </div>

      <div style={{ marginBottom: 14 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#0A0A0F" }}>Anthropic API Key</span>
          {statusPill(info.anthropicConfigured)}
        </div>
        <input type="password" value={anthropicInput} onChange={(e) => setAnthropicInput(e.target.value)}
          placeholder={info.anthropicConfigured ? "Enter new key to replace…" : "Paste your Anthropic API key…"}
          style={{ ...S.input }} />
      </div>

      <div style={{ marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#0A0A0F" }}>OpenAI API Key</span>
          {statusPill(info.openaiConfigured)}
        </div>
        <input type="password" value={openaiInput} onChange={(e) => setOpenaiInput(e.target.value)}
          placeholder={info.openaiConfigured ? "Enter new key to replace…" : "Paste your OpenAI API key…"}
          style={{ ...S.input }} />
      </div>

      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#0A0A0F", marginBottom: 6 }}>CEO Password</div>
        <input type="password" value={ceoPassword} onChange={(e) => setCeoPassword(e.target.value)}
          placeholder="Required to save changes" style={{ ...S.input, maxWidth: 280 }} />
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <button onClick={save} disabled={!canSave || saving} style={{ ...S.addBtn, opacity: !canSave || saving ? 0.5 : 1, cursor: !canSave || saving ? "not-allowed" : "pointer" }}>
          {saving ? "Saving…" : "Save"}
        </button>
        {msg && <span style={{ fontSize: 13, color: "#34d399", fontWeight: 600 }}>{msg}</span>}
      </div>
      {err && (
        <div style={{ marginTop: 12, padding: "10px 14px", background: "rgba(239,68,68,0.1)", border: "1px solid #ef4444", borderRadius: 0, fontSize: 14, color: "#ef4444" }}>{err}</div>
      )}
    </div>
  );
}

// ─── Google Drive Archive (CEO only) ──────────────────
function GoogleDriveCard() {
  const [info, setInfo] = useState({ configured: false, serviceAccountEmail: "", etsyLabelsFolder: "", productDevFolder: "", printfarmCatalogFolder: "" });
  const [saJson, setSaJson] = useState("");
  const [keyFileName, setKeyFileName] = useState("");
  const [etsyFolder, setEtsyFolder] = useState("");
  const [pdFolder, setPdFolder] = useState("");
  const [pfFolder, setPfFolder] = useState("");
  const [ceoPassword, setCeoPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const currentUser = (() => {
    try { return JSON.parse(sessionStorage.getItem("nycmfg-user")); } catch { return null; }
  })();

  useEffect(() => {
    fetch(`${API_URL}/api/drive/settings`)
      .then((r) => r.json())
      .then((d) => { setInfo(d); setEtsyFolder(d.etsyLabelsFolder || ""); setPdFolder(d.productDevFolder || ""); setPfFolder(d.printfarmCatalogFolder || ""); })
      .catch(() => {});
  }, []);

  const save = () => {
    setSaving(true); setErr(""); setMsg("");
    // Passwords are hashed server-side and never stored client-side — the CEO
    // types it here and the backend verifies before writing.
    fetch(`${API_URL}/api/drive/settings`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        empId: currentUser?.empId,
        password: ceoPassword,
        serviceAccountJson: saJson.trim(),
        etsyLabelsFolder: etsyFolder.trim(),
        productDevFolder: pdFolder.trim(),
        printfarmCatalogFolder: pfFolder.trim(),
      }),
    })
      .then(async (r) => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.error || `Server returned ${r.status}`); return d; })
      // Keep ceoPassword so "Test Connection" (also CEO-gated) works right
      // after saving — only the secret inputs are cleared.
      .then((d) => { setInfo((p) => ({ ...p, ...d })); setSaJson(""); setKeyFileName(""); setMsg("Saved!"); setTimeout(() => setMsg(""), 2000); setSaving(false); })
      .catch((e) => { setErr(`Failed to save: ${e.message}`); setSaving(false); });
  };

  const test = () => {
    setTesting(true); setErr(""); setMsg("");
    fetch(`${API_URL}/api/drive/test`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ empId: currentUser?.empId, password: ceoPassword }),
    })
      .then(async (r) => { const d = await r.json().catch(() => ({})); if (!r.ok || !d.ok) throw new Error(d.error || `Server returned ${r.status}`); return d; })
      .then((d) => { setMsg(`Connected — folder "${d.folderName}"`); setTimeout(() => setMsg(""), 5000); setTesting(false); })
      .catch((e) => { setErr(`Test failed: ${e.message}`); setTesting(false); });
  };

  const onKeyFile = (e) => {
    const f = e.target.files[0];
    e.target.value = "";
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => {
      const text = String(reader.result || "");
      setSaJson(text);
      try {
        const j = JSON.parse(text);
        setKeyFileName(`${f.name} — ${j.client_email || "key loaded"}`);
      } catch {
        setKeyFileName(`${f.name} — ⚠ not valid JSON`);
      }
    };
    reader.readAsText(f);
  };

  const statusPill = (ok) => (
    <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 13, fontWeight: 600, color: ok ? "#34d399" : "rgba(10,10,15,0.45)" }}>
      {ok ? "Configured ✓" : "Not set"}
    </span>
  );

  return (
    <div style={{ background: "#FFFFFF", border: "2px solid #0A0A0F", borderRadius: 0, padding: 20, marginBottom: 24 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
        <h3 style={{ fontSize: 14, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1.5, color: "rgba(10,10,15,0.58)" }}>Google Drive Archive</h3>
        {statusPill(info.configured)}
      </div>
      <p style={{ fontSize: 13, color: "rgba(10,10,15,0.58)", marginBottom: 16, lineHeight: 1.5 }}>
        A service account that archives files to a Shared Drive (Etsy Label Bot PDFs, Product Development attachments).
        Paste the service-account JSON key and the target folder IDs. The key is stored on the server and never displayed.
        {info.serviceAccountEmail ? <> Robot account: <code style={{ fontFamily: "'JetBrains Mono', monospace", color: "#0A0A0F" }}>{info.serviceAccountEmail}</code> — share each Drive folder with it.</> : null}
      </p>

      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#0A0A0F", marginBottom: 6 }}>Service Account JSON Key</div>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap" }}>
          <label style={{ ...S.clearBtn, fontSize: 13, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}>
            Upload JSON key file
            <input type="file" accept=".json,application/json" onChange={onKeyFile} style={{ display: "none" }} />
          </label>
          {keyFileName && <span style={{ fontSize: 12, color: "#34d399", fontWeight: 600 }}>{keyFileName}</span>}
        </div>
        <textarea value={saJson} onChange={(e) => { setSaJson(e.target.value); setKeyFileName(""); }}
          placeholder={info.configured ? "…or paste a new key to replace" : "…or paste the full service-account JSON here"}
          style={{ ...S.input, minHeight: 70, fontFamily: "'JetBrains Mono', monospace", fontSize: 12, resize: "vertical" }} />
      </div>

      <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: "#0A0A0F", marginBottom: 6 }}>Etsy Labels Folder ID</div>
          <input value={etsyFolder} onChange={(e) => setEtsyFolder(e.target.value)} placeholder="Drive folder ID" style={{ ...S.input }} />
        </div>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: "#0A0A0F", marginBottom: 6 }}>Product Dev Folder ID</div>
          <input value={pdFolder} onChange={(e) => setPdFolder(e.target.value)} placeholder="Drive folder ID" style={{ ...S.input }} />
        </div>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: "#0A0A0F", marginBottom: 6 }}>PrintFarm Catalog Folder ID</div>
          <input value={pfFolder} onChange={(e) => setPfFolder(e.target.value)} placeholder="Drive folder ID" style={{ ...S.input }} />
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#0A0A0F", marginBottom: 6 }}>CEO Password</div>
        <input type="password" value={ceoPassword} onChange={(e) => setCeoPassword(e.target.value)}
          placeholder="Required to save or test" style={{ ...S.input, maxWidth: 280 }} />
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <button onClick={save} disabled={saving || !ceoPassword.trim()} style={{ ...S.addBtn, opacity: (saving || !ceoPassword.trim()) ? 0.5 : 1, cursor: (saving || !ceoPassword.trim()) ? "not-allowed" : "pointer" }}>
          {saving ? "Saving…" : "Save"}
        </button>
        <button onClick={test} disabled={testing || !info.configured || !ceoPassword.trim()} style={{ ...S.clearBtn, fontSize: 13, opacity: (testing || !info.configured || !ceoPassword.trim()) ? 0.5 : 1 }}>
          {testing ? "Testing…" : "Test Connection"}
        </button>
        {msg && <span style={{ fontSize: 13, color: "#34d399", fontWeight: 600 }}>{msg}</span>}
      </div>
      {err && (
        <div style={{ marginTop: 12, padding: "10px 14px", background: "rgba(239,68,68,0.1)", border: "1px solid #ef4444", borderRadius: 0, fontSize: 14, color: "#ef4444" }}>{err}</div>
      )}
    </div>
  );
}

// ─── Main Page ────────────────────────────────────────
export default function SettingsPage({ employees, onRefresh, store }) {
  const [saveMsg, setSaveMsg] = useState("");
  const [editingSection, setEditingSection] = useState(null);

  const currentUser = (() => {
    try { return JSON.parse(sessionStorage.getItem("nycmfg-user")); } catch { return null; }
  })();

  const handleLogout = () => {
    sessionStorage.removeItem("nycmfg-auth");
    sessionStorage.removeItem("nycmfg-user");
    window.location.href = "/";
  };

  const activeSections = HQ_SECTIONS;

  const getAccessNames = (sectionKey) => {
    return employees.filter((e) => (e.permissions || []).includes(sectionKey)).map((e) => e.name);
  };

  return (
    <div>
      <div style={{ marginBottom: 4 }}>
        <h2 style={{ fontFamily: "'Archivo Black', 'Archivo', sans-serif", fontSize: 32, fontWeight: 900, color: "#0A0A0F", letterSpacing: "-0.02em", textTransform: "uppercase", lineHeight: 1, marginBottom: 4 }}>Settings</h2>
        <p style={{ fontSize: 14, color: "rgba(10,10,15,0.58)", marginBottom: 20 }}>Manage accounts, permissions, and preferences</p>
      </div>

      {/* Current User */}
      {currentUser && (
        <div style={{ background: "#FFFFFF", border: "2px solid #0A0A0F", borderRadius: 0, padding: 20, marginBottom: 24 }}>
          <h3 style={{ fontSize: 14, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1.5, color: "rgba(10,10,15,0.58)", marginBottom: 14 }}>Logged In As</h3>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div style={{ fontSize: 20, fontWeight: 700, color: "#0A0A0F" }}>{currentUser.name}</div>
              <div style={{ fontSize: 14, color: "rgba(10,10,15,0.58)" }}>{currentUser.role === "admin" ? "Administrator" : "Employee"} — ID: {currentUser.empId}</div>
            </div>
            <button onClick={handleLogout} style={{
              padding: "8px 20px", borderRadius: 0, border: "1px solid #ef4444",
              background: "transparent", color: "#ef4444", fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: "'Archivo', sans-serif",
            }}>
              Sign Out
            </button>
          </div>
        </div>
      )}

      {/* AI / API Keys — CEO only (employee 01) */}
      {currentUser?.empId === "01" && <AIKeysCard />}

      {/* Google Drive Archive — CEO only (employee 01) */}
      {currentUser?.empId === "01" && <GoogleDriveCard />}

      {saveMsg && <div style={{ fontSize: 14, color: "#34d399", textAlign: "center", marginBottom: 16 }}>{saveMsg}</div>}

      {/* Employee Accounts */}
      <div style={{ background: "#FFFFFF", border: "2px solid #0A0A0F", borderRadius: 0, overflow: "hidden", marginBottom: 24 }}>
        <div style={{ padding: "12px 20px", background: "#FFFFFF", borderBottom: "2px solid #0A0A0F", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 14, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1.5, color: "rgba(10,10,15,0.58)" }}>Employee Accounts</span>
        </div>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={{ ...S.th, width: "10%" }}>ID</th>
              <th style={{ ...S.th, width: "45%" }}>Name</th>
              <th style={{ ...S.th, width: "25%" }}>Role</th>
            </tr>
          </thead>
          <tbody>
            {employees.map((emp) => (
              <tr key={emp.id}>
                <td style={{ ...S.td, fontFamily: "'JetBrains Mono', monospace", fontSize: 15, color: "rgba(10,10,15,0.58)", fontWeight: 600 }}>{emp.empId || "—"}</td>
                <td style={{ ...S.td, fontWeight: 600, color: "#0A0A0F" }}>{emp.name}</td>
                <td style={S.td}>
                  <span style={{
                    display: "inline-block", padding: "2px 10px", borderRadius: 0, fontSize: 13, fontWeight: 600,
                    background: emp.role === "admin" ? "rgba(0,51,255,0.12)" : "#F4F2EC",
                    color: emp.role === "admin" ? "#0033FF" : "rgba(10,10,15,0.58)",
                  }}>
                    {emp.role === "admin" ? "Admin" : "Employee"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Permissions — scoped to current store */}
      {[
        ...(store === "nycmfg" ? [{ title: "HQ Permissions", sections: activeSections }] : []),
        ...(store === "designshop" ? [{ title: "Design Shop Permissions", sections: DS_SECTIONS }] : []),
        ...(store === "vibratovault" ? [{ title: "Vibrato Vault Permissions", sections: VV_SECTIONS }] : []),
      ].map(({ title, sections }) => (
        <div key={title} style={{ background: "#FFFFFF", border: "2px solid #0A0A0F", borderRadius: 0, overflow: "hidden", marginBottom: 24 }}>
          <div style={{ padding: "12px 20px", background: "#FFFFFF", borderBottom: "2px solid #0A0A0F" }}>
            <span style={{ fontSize: 14, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1.5, color: "rgba(10,10,15,0.58)" }}>{title}</span>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {sections.map((sec) => {
              const names = getAccessNames(sec.key);
              return (
                <div
                  key={sec.key}
                  onClick={() => setEditingSection(sec)}
                  style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "12px 20px", borderBottom: "1px solid rgba(10,10,15,0.12)",
                    cursor: "pointer", transition: "background .1s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(22,45,80,0.3)")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <span style={{ fontSize: 15, fontWeight: 600, color: "#0A0A0F" }}>{sec.label}</span>
                    <span style={{ fontSize: 13, color: "rgba(10,10,15,0.58)", background: "#F4F2EC", padding: "1px 8px", borderRadius: 0}}>
                      {names.length}
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap", justifyContent: "flex-end" }}>
                      {names.slice(0, 4).map((n) => (
                        <span key={n} style={{
                          display: "inline-block", padding: "2px 8px", borderRadius: 0,
                          fontSize: 12, fontWeight: 500, background: "#F4F2EC", color: "#0A0A0F",
                        }}>
                          {n}
                        </span>
                      ))}
                      {names.length > 4 && (
                        <span style={{ fontSize: 12, color: "rgba(10,10,15,0.58)" }}>+{names.length - 4}</span>
                      )}
                    </div>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(10,10,15,0.58)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {/* Edit popup */}
      {editingSection && (
        <PermissionPopup
          section={editingSection}
          employees={employees}
          onClose={() => setEditingSection(null)}
          onRefresh={() => { onRefresh(); }}
        />
      )}

      {/* Owner Profit Splits (store-scoped, editable by Daniel only) */}
      {(store === "designshop" || store === "vibratovault") && <OwnerProfitSplits store={store} readOnly={currentUser?.empId !== "01"} />}

      {/* Time Clock Link */}
      <div style={{ background: "#FFFFFF", border: "2px solid #0A0A0F", borderRadius: 0, padding: 20 }}>
        <h3 style={{ fontSize: 14, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1.5, color: "rgba(10,10,15,0.58)", marginBottom: 14 }}>Employee Time Clock Link</h3>
        <p style={{ fontSize: 14, color: "rgba(10,10,15,0.58)", marginBottom: 10 }}>Share this link with employees so they can clock in/out:</p>
        <div style={{
          padding: "10px 16px", borderRadius: 0, background: "#FFFFFF", border: "2px solid #0A0A0F",
          fontFamily: "'JetBrains Mono', monospace", fontSize: 14, color: "#0033FF",
          display: "flex", justifyContent: "space-between", alignItems: "center",
        }}>
          <span>{window.location.origin}/employeetc</span>
          <button onClick={() => { navigator.clipboard.writeText(`${window.location.origin}/employeetc`); setSaveMsg("Link copied!"); setTimeout(() => setSaveMsg(""), 2000); }}
            style={{ ...S.iconBtn, borderColor: "#0033FF", color: "#0033FF", padding: "4px 10px", fontSize: 12 }}>
            <CheckIcon /> Copy
          </button>
        </div>
      </div>
    </div>
  );
}
